import { Link } from "react-router-dom";
import { Check, Minus } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { PackagesGrid } from "@/components/PackagesGrid";
import { Reveal } from "@/components/Reveal";
import { ADDONS } from "@/lib/data";

const ROWS = [
  { label: "Number of totes", vals: ["25", "45", "75", "Custom"] },
  { label: "Rental length", vals: ["1 week", "2 weeks", "3 weeks", "Flexible"] },
  { label: "Free delivery", vals: [true, true, true, true] },
  { label: "Free pickup", vals: [true, true, true, true] },
  { label: "Moving dollies", vals: [false, "2", "4", "Optional"] },
  { label: "Wardrobe totes", vals: [false, false, true, "Optional"] },
  { label: "Priority scheduling", vals: [false, false, true, true] },
];
const COLS = ["Apartment", "House", "Large Home", "Custom"];

const Cell = ({ v }) => {
  if (v === true) return <Check className="h-5 w-5 text-crate-yellow mx-auto" />;
  if (v === false) return <Minus className="h-5 w-5 text-white/20 mx-auto" />;
  return <span className="text-white/80 font-semibold">{v}</span>;
};

export default function Pricing() {
  return (
    <div data-testid="pricing-page">
      <PageHero overline="Pricing" title="Transparent pricing for every kind of move." subtitle="Free delivery and pickup on every package. No deposits, no hidden fees — just move smarter." />

      <section className="mx-auto max-w-7xl px-6 md:px-12 pb-20">
        <PackagesGrid />
      </section>

      {/* Comparison table */}
      <section className="mx-auto max-w-7xl px-6 md:px-12 pb-20" data-testid="comparison-table">
        <Reveal>
          <h2 className="font-heading font-black text-3xl md:text-5xl text-white tracking-tighter mb-10">Compare packages</h2>
          <div className="overflow-x-auto rounded-2xl border border-white/10">
            <table className="w-full min-w-[640px] text-center">
              <thead>
                <tr className="bg-crate-surface">
                  <th className="text-left font-heading font-bold text-white p-5 text-sm uppercase tracking-wider">Features</th>
                  {COLS.map((c) => (
                    <th key={c} className={`font-heading font-bold p-5 ${c === "Large Home" ? "text-crate-yellow" : "text-white"}`}>{c}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ROWS.map((r, i) => (
                  <tr key={r.label} className={i % 2 ? "bg-crate-surface/30" : ""}>
                    <td className="text-left text-white/70 p-5 font-semibold">{r.label}</td>
                    {r.vals.map((v, j) => <td key={j} className="p-5"><Cell v={v} /></td>)}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>
      </section>

      {/* Add-ons */}
      <section className="mx-auto max-w-7xl px-6 md:px-12 pb-24 md:pb-32" data-testid="addons">
        <Reveal>
          <h2 className="font-heading font-black text-3xl md:text-5xl text-white tracking-tighter mb-10">Optional add-ons</h2>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {ADDONS.map((a) => (
              <div key={a.name} className="flex items-center justify-between rounded-2xl bg-crate-surface border border-white/10 px-6 py-5 hover:border-crate-yellow transition-colors">
                <span className="text-white font-semibold">{a.name}</span>
                <span className="text-crate-yellow font-heading font-bold">{a.price}</span>
              </div>
            ))}
          </div>
          <Link to="/reserve" className="mt-12 inline-flex rounded-full bg-crate-yellow text-crate-black font-bold px-8 py-4 hover:bg-white transition-colors" data-testid="pricing-reserve-btn">
            Reserve Your Package
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
